module.exports = __webpack_public_path__ + "static/img/default-banner.03452e59.jpg";